// extracted by mini-css-extract-plugin
export default {"areaTooltip":"Ya9HJ___ListingMediaPhotoSection-module__areaTooltip","areaOverlay":"_0QB9l___ListingMediaPhotoSection-module__areaOverlay"};